import maInputRadio from '../radio'

// constants
import { ROOF_ANGLE } from '@/constants'

// utils
import requirePath from '@/utils/requirePath'

/**
 * @module
 * @name InputImgRadio
 * @extends inputRadio
 */
export default {
  name: 'inputImgRadio',
  extends: maInputRadio,

  /**
   * @property {Array} options Options array, should contain at least key, value
   *                           per option.
   * @property {String} name name of the element, if provided.
   */
  props: {
    name: '',

    options: {
      type: Array,
      required: true
    },

    isExternalImage: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    /**
     * This computed returns true if the component is being used to roof's
     * angles.
     */
    isRoofAngle () {
      return this.name === ROOF_ANGLE
    }
  },

  methods: {
    /**
     * @function
     * @name isChecked
     * @description Returns if inputKey matches with component selected value.
     * @param {inputKey} inputKey Object key.
     */
    isChecked: function (inputKey) {
      return this.value === inputKey
    },
    labelClassSelected: function (inputKey) {
      if (this.isChecked(inputKey)) {
        return 'selectedImg'
      }
    },
    /**
     * @function
     * @name handleClick
     * @description Emits an event to be captured by parent component.
     * @param {String} inputKey Clicked object key.
     */
    handleClick: function (inputKey) {
      this.$emit('change', inputKey)
    },
    /**
     * If the option has a not empty image string, returns true.
     */
    elementHasImage (option) {
      return option && option.image.length > 0
    },
    /**
     * Used to assing the url to the background property.
     */
    inlineStyle (option) {
      let url = this.isExternalImage ? option.image : requirePath(option.image)
      return {
        backgroundImage: `url(${url})`
      }
    },
    /**
     * Returns the option literal modified for roof's angles.
     */
    getLiteral (option) {
      return this.isRoofAngle ? option.literal + 'º' : option.literal
    }
  }
}
